import { api } from '../api';
/**
 * 룰렛 이벤트 API
 */
export const RouletteApi = {
	GetRouletteCount: (event_se, member_se) =>
		api.get(`api/roulette/count?event_se=${event_se}&&member_se=${member_se}`),
	GetRouletteRank: (event_se, member_se) =>
		api.get(
			`api/roulette/ranking?event_se=${event_se}&&member_se=${member_se}`
		),
	GetRouletteGifticons: (event_se, member_se) =>
		api.get(
			`api/roulette/gifticons?event_se=${event_se}&&member_se=${member_se}`
		),
	GetRoulettePhoneNumber: (member_se) =>
		api.get(`api/roulette/phone-number?member_se=${member_se}`),
	PatchSavePhoneNumber: (data) =>
		api.patch(`api/roulette/phone-number`, data),
	PostRotateRoulette: (data) => api.post(`api/roulette/rotate-roulette`, data),
};
